
const digest = 'c2e2ddb77919338656651765277c923dd10c35fe026cf61e82612b94370d8261';
const classes = {"wrapper":"_wrapper_1miuw_1","title":"_title_1miuw_8","line":"_line_1miuw_12"};
const css = `._wrapper_1miuw_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
}
._wrapper_1miuw_1 ._title_1miuw_8 {
  font-weight: 600;
  font-size: 12px;
}
._wrapper_1miuw_1 ._line_1miuw_12 {
  height: 1px;
  flex-grow: 1;
  background-color: #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  